"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStore = exports.resetStore = void 0;
const idb_keyval_1 = require("idb-keyval");
let storeCache = {};
// only used for test purposes - this needs to be reset between tests otherwise the database never gets recreated
function resetStore() {
    storeCache = {};
}
exports.resetStore = resetStore;
function getStore({ dbName = "keyval-store", storeName = "keyval" } = {}) {
    function fetchOrCreateStore() {
        if (storeCache[dbName] && !storeCache[dbName][storeName]) {
            throw new Error(`
        \`getStore\` - cannot use object store ${storeName} in database ${dbName} - this database already exists with store names: ${Object.keys(storeCache[dbName]).join(",")}.
        To use a custom object store please use a different, unused, database name.
      `);
        }
        let customStore = storeCache[dbName]?.[storeName];
        if (!customStore) {
            const request = indexedDB.open(dbName);
            request.onupgradeneeded = () => {
                request.result.createObjectStore(storeName);
            };
            // need to use addEventListener here rather than setting onsuccess, as promisifyRequest overwrites
            // the onsuccess property
            request.addEventListener("success", () => {
                // we need to ensure the connection is closed when the application is open
                // in another tab and tries to delete the database, otherwise all requests
                // get blocked
                request.result.addEventListener("versionchange", () => {
                    request.result.close();
                });
            });
            const dbp = (0, idb_keyval_1.promisifyRequest)(request);
            customStore = (txMode, callback) => dbp.then((db) => {
                const transaction = db.transaction(storeName, txMode);
                return callback(transaction.objectStore(storeName));
            });
            if (!storeCache[dbName]) {
                storeCache[dbName] = {};
            }
            storeCache[dbName][storeName] = customStore;
        }
        return customStore;
    }
    function get(key) { return (0, idb_keyval_1.get)(key, fetchOrCreateStore()); }
    ;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(key, value) { return (0, idb_keyval_1.set)(key, value, fetchOrCreateStore()); }
    ;
    function del(key) { return (0, idb_keyval_1.del)(key, fetchOrCreateStore()); }
    ;
    function getMany(keys) { return (0, idb_keyval_1.getMany)(keys, fetchOrCreateStore()); }
    function setMany(entries) { return (0, idb_keyval_1.setMany)(entries, fetchOrCreateStore()); }
    async function deleteKeys(keyMatchingFunction) {
        const allKeys = await (0, idb_keyval_1.keys)(fetchOrCreateStore());
        const keysToDelete = allKeys.filter(keyMatchingFunction);
        (0, idb_keyval_1.delMany)(keysToDelete, fetchOrCreateStore());
    }
    return { customStore: fetchOrCreateStore(), get, set, del, getMany, setMany, deleteKeys, keys: idb_keyval_1.keys };
}
exports.getStore = getStore;
//# sourceMappingURL=idb-store.js.map